<div
  #bannerEl
  *ngIf="state.enabled"
  class="incident-banner"
  [class.with-super-admin-bar]="superAdminContext.present"
  role="alert"
>
  <span class="material-icons">warning_amber</span>
  <span class="incident-text">{{ state.message }}</span>
  <button
    *ngIf="state.message"
    type="button"
    class="incident-more"
    (click)="openDetails()"
  >…more</button>
</div>

